<lib-unauthenticated-layout [backgroundImageUrl]="backgroundImageUrl" [title]="title" [overlayClass]="overlayClass" [headerClass]="headerClass">
  <div title>
    <h2 class="mb-6 text-center text-2xl/9 font-bold tracking-tight" [ngClass]="titleClass">
      {{ title || ('auth.login.title' | translate) }}
    </h2>
    <p class="mt-2 text-center text-sm" [ngClass]="subtitleClass">
      Accede con tus credenciales para continuar
    </p>
  </div>

  <div content>
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="form"
      class="mx-auto flex w-full max-w-sm flex-col space-y-5"
    >
      <!-- Email / RUC -->
      <div class="flex flex-col gap-1">
        <p-float-label variant="on">
          <label class="texto-secundario" for="email">
            {{ (loginType === 'ruc' ? 'auth.login.ruc' : 'auth.login.email') | translate }}
          </label>
          <input
            [type]="loginType === 'ruc' ? 'text' : 'email'"
            class="w-full"
            formControlName="email"
            id="email"
            pInputText
          />
        </p-float-label>

        <small
          [style.visibility]="
            form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)
              ? 'visible'
              : 'hidden'
          "
          class="text-red-500 text-xs min-h-[1rem]"
          >
          {{ getEmailError() }}
        </small>
      </div>

      <!-- Password -->
      <div class="flex flex-col gap-1">
        <p-float-label variant="on">
          <p-password
            [feedback]="false"
            formControlName="password"
            id="password"
            inputStyleClass="w-full"
            styleClass="w-full"
            toggleMask="true"
          ></p-password>
          <label for="password">
            {{ 'auth.login.password' | translate }}
          </label>
        </p-float-label>

        <small
          [style.visibility]="
            form.get('password')?.invalid &&
            (form.get('password')?.dirty || form.get('password')?.touched)
              ? 'visible'
              : 'hidden'
          "
          class="text-red-500 text-xs min-h-[1rem]"
          >
          {{ getPasswordError() }}
        </small>
      </div>
      <div class="my-3 flex items-center justify-between">
        @if (!hideI18n) {
          <lib-i18n [variant]="variant || 'toggle'" />
        }
        <!-- Register link -->
        @if (!hideForgotPassword) {
          <div class="flex items-center justify-end">
            <div class="text-sm/6">
              <a
                [routerLink]="['/reset-password']"
                class="text-sm font-medium text-primary-600 transition-colors hover:text-primary-500 hover:underline dark:text-primary-400 dark:hover:text-primary-300"
              >
                {{ 'auth.login.forgotPassword' | translate }}
              </a>
            </div>
          </div>
        }
      </div>

      <!-- Submit button -->
      <p-button
        [disabled]="form.invalid"
        [loading]="loading$ | async"
        label="{{ 'auth.login.submit' | translate }}"
        styleClass="w-full"
        type="submit"
        />

      @if (!hideAzureLogin) {
        <p-button (onClick)="onAzureLogin()" [outlined]="true" styleClass="w-full" type="button">
          <div class="flex items-center justify-center gap-2">
            <img
              alt="Azure"
              class="h-5 w-5 object-contain"
              ngSrc="assets/images/Azure-Logo-PNG-Photo.png"
            />
            <span class="font-semibold">Ingresar con Azure</span>
          </div>
        </p-button>
      }

      @if (!hideGoogleLogin) {
        <p-button (onClick)="onGoogleLogin()" [outlined]="true" styleClass="w-full" type="button">
          <div class="flex items-center justify-center gap-2">
            <img alt="Google" class="h-5 w-5 object-contain" ngSrc="assets/images/google-logo.png" width="20" height="20" />
            <span class="font-semibold">Ingresar con Google</span>
          </div>
        </p-button>
      }

      @if (!hideMicrosoftLogin) {
        <p-button (onClick)="onMicrosoftLogin()" [outlined]="true" styleClass="w-full" type="button">
          <div class="flex items-center justify-center gap-2">
            <img alt="Microsoft" class="h-5 w-5 object-contain" ngSrc="assets/images/microsoft-logo.png" width="20" height="20" />
            <span class="font-semibold">Ingresar con Microsoft</span>
          </div>
        </p-button>
      }


      @if (!hideRegister) {
        <div class="flex items-center justify-center !mt-4">
          <div class="text-sm/6">
            <a
              [routerLink]="['/register']"
              class="font-medium text-primary-600 transition-colors hover:text-primary-500 hover:underline dark:text-primary-400 dark:hover:text-primary-300"
            >
              {{ 'auth.login.notHaveAccount' | translate }}
            </a>
          </div>
        </div>
      }
      <ng-content select="[login-extra]"></ng-content>
    </form>
  </div>
</lib-unauthenticated-layout>
